import { useState } from "react";

import { Button, Select, TextInput } from "@/components/field";

interface ListInputProps {
	id: string;
	onChange: (values: string[]) => void;
	/** With options, values are picked from a list instead of typed. */
	options?: { label: string; value: string }[];
	placeholder?: string;
	values: string[];
}

/** A removable list of strings, typed or picked from a list. */
export const ListInput = ({
	id,
	onChange,
	options,
	placeholder,
	values,
}: ListInputProps) => {
	const [entry, setEntry] = useState("");
	const add = () => {
		const value = entry.trim();
		if (value && !values.includes(value)) {
			onChange([...values, value]);
		}
		setEntry("");
	};
	const available = options?.filter((option) => !values.includes(option.value));

	return (
		<div className="flex flex-col gap-2">
			{values.length > 0 && (
				<ul className="flex flex-wrap gap-1">
					{values.map((value) => (
						<li
							className="border-secondary text-primary flex items-center gap-1 rounded border px-1.5 py-0.5 text-xs"
							key={value}
						>
							<span>{value}</span>
							<button
								aria-label={`Remove ${value}`}
								className="text-tertiary hover:text-error-primary"
								onClick={() => onChange(values.filter((v) => v !== value))}
								type="button"
							>
								×
							</button>
						</li>
					))}
				</ul>
			)}
			<div className="flex gap-2">
				{available ? (
					<Select
						id={id}
						onChange={(event) => setEntry(event.target.value)}
						value={entry}
					>
						<option value="">Choose…</option>
						{available.map((option) => (
							<option key={option.value} value={option.value}>
								{option.label}
							</option>
						))}
					</Select>
				) : (
					<TextInput
						id={id}
						onChange={(event) => setEntry(event.target.value)}
						onKeyDown={(event) => {
							if (event.key === "Enter") {
								event.preventDefault();
								add();
							}
						}}
						placeholder={placeholder}
						value={entry}
					/>
				)}
				<Button
					disabled={!entry.trim()}
					onClick={add}
					type="button"
					variant="secondary"
				>
					Add
				</Button>
			</div>
		</div>
	);
};
